import { Box } from '@rbilabs/universal-components';

import PickupTimeSelector from 'components/pickup-time-selector';
import { PickupNowEtaIndicator } from 'components/pickup-time-selector/pickup-now-eta-indicator';
import { t } from 'state/intl/translations';
import { isDelivery } from 'utils/service-mode';

import SectionHeading from '../section-heading';

import DeliveryDetails from './delivery-details';
import { PickupDetails } from './pickup-details';
import { PickupTimeHeadingContainer } from './styled';
import { ICartDetailsProps } from './types';

export const Details: React.FC<React.PropsWithChildren<ICartDetailsProps>> = ({
  readOnly = false,
  serverOrder,
  serviceMode,
  setAreDeliveryDetailsValid,
  isOrderTimedFire,
  phoneNumberInputRef,
  deliveryDetailsErrors,
}) => {
  const isDeliveryOrder = isDelivery(serviceMode);

  const sectionHeading = isDeliveryOrder ? 'deliveryDetails' : 'restaurantDetails';

  return (
    <>
      {isDeliveryOrder ? (
        <DeliveryDetails
          serverOrder={serverOrder}
          setAreDeliveryDetailsValid={setAreDeliveryDetailsValid}
          sectionHeading={sectionHeading}
          phoneNumberInputRef={phoneNumberInputRef}
          deliveryDetailsErrors={deliveryDetailsErrors}
        />
      ) : (
        <PickupDetails serviceMode={serviceMode} readOnly={readOnly} />
      )}
      {isOrderTimedFire && (
        <Box>
          <PickupTimeHeadingContainer>
            <SectionHeading>{t('pickUpTime')}</SectionHeading>
            <PickupNowEtaIndicator />
          </PickupTimeHeadingContainer>
          <PickupTimeSelector />
        </Box>
      )}
    </>
  );
};
